import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kalyaninagartomumbaitaxi() {



const cardData = {
  keyword: " Kalyani Nagar to Mumbai Taxi ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Kalyani Nagar to Mumbai taxi services, offering hassle-free transportation for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups ensure a smooth journey from Kalyani Nagar to Mumbai. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kalyani Nagar to Mumbai taxi services.",

topPlaces: [
 
  {
    title: "Gilbert Hill",
    description: "Gilbert Hill is a rare volcanic rock formation that dates back millions of years and stands as one of Mumbai's hidden attractions. Renting an Innova Crysta in Pune provides a comfortable journey for travelers looking to discover unique geological landmarks and enjoy panoramic city views from the hilltop."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, popularly known as the Queen's Necklace, is one of Mumbai's most iconic waterfront destinations. Travelers hiring an Innova Crysta on rent in Pune can relax along the scenic promenade, enjoy breathtaking sunset views, sample local street food, and experience the vibrant charm of Mumbai's coastline."
  },
   {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is one of Mumbai's most popular seaside promenades, offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing along the waterfront, exploring nearby cafés, and visiting famous celebrity residences. It is an excellent destination for evening walks and photography."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most recognizable monument and a must-visit destination for travelers. Renting an Innova Crysta in Pune makes the journey smooth and comfortable for families and groups planning a Mumbai sightseeing tour. Visitors can admire the historic architecture, enjoy ferry rides to Elephanta Island, and capture memorable photographs overlooking the Arabian Sea."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake offers a peaceful escape from Mumbai's busy streets with scenic waterfront views, boating opportunities, and nearby restaurants. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this picturesque destination for a relaxing outing with family and friends. The surrounding greenery and modern skyline create a perfect setting for photography and leisure."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is one of Mumbai's most famous religious landmarks, situated on a small islet in the Arabian Sea. Visitors hiring an Innova Crysta on rent in Pune can enjoy a convenient drive to this spiritual destination and admire its beautiful Indo-Islamic architecture, peaceful atmosphere, and scenic sea views."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most visited beaches, attracting visitors with its lively atmosphere, street food, and spectacular sunsets. Booking an Innova Crysta on rent in Pune allows travelers to enjoy a comfortable road journey before spending quality time by the sea with family and friends."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural marvel and meditation center located near Gorai. Travelers renting an Innova Crysta in Pune can comfortably reach this peaceful attraction to admire its magnificent golden dome, explore the meditation halls, and experience a calm and spiritual environment."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is a vibrant shopping destination filled with fashion boutiques, handicraft stalls, cafés, and restaurants. Visitors booking an Innova Crysta on rent in Pune can conveniently explore this bustling market while enjoying shopping, local cuisine, and the colonial charm of South Mumbai."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves are a UNESCO World Heritage Site renowned for their ancient rock-cut temples and magnificent sculptures of Lord Shiva. Travelers choosing an Innova Crysta on rent in Pune can comfortably travel to Mumbai before taking a ferry to Elephanta Island for an unforgettable historical experience."
  },
],



services: [
{
name: "Kalyani Nagar to Mumbai Taxi Fare",
description: "Kalyani Nagar to Mumbai taxi fare services provide transparent pricing for passengers planning intercity travel from Kalyani Nagar in Pune to Mumbai city. Travelers can choose vehicles such as sedan, Ertiga, or Innova depending on comfort and budget. Professional drivers ensure safe highway journeys via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, and residential societies in Kalyani Nagar."
},
{
name: "Kalyani Nagar to Mumbai Airport Cab",
description: "Kalyani Nagar to Mumbai Airport cab service offers reliable airport transportation for passengers traveling to Chhatrapati Shivaji Maharaj International Airport. Vehicles provide comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, and hotels in Kalyani Nagar."
},
{
name: "Kalyani Nagar to Dadar Cab",
description: "Kalyani Nagar to Dadar cab service provides dependable transportation between Pune’s Kalyani Nagar area and Dadar in Mumbai. Comfortable vehicles with experienced drivers ensure safe expressway travel. Pickup services are available from homes, offices, and hotels across Kalyani Nagar."
},
{
name: "Kalyani Nagar to Mumbai International Airport Cab",
description: "Kalyani Nagar to Mumbai International Airport cab service offers convenient transportation for travelers heading to Mumbai’s international airport terminal. Vehicles are comfortable and suitable for long-distance highway travel with luggage capacity for airport passengers. Professional drivers ensure punctual pickup and safe journeys."
},
{
name: "Kalyani Nagar to Mumbai One Day Cab",
description: "Kalyani Nagar to Mumbai one day cab service offers flexible travel options for passengers planning same-day return trips between Pune and Mumbai. Comfortable vehicles with professional drivers ensure safe journeys via the expressway. Pickup services are available from homes, offices, and hotels across Kalyani Nagar."
},
{
name: "Kalyani Nagar to Mumbai Airport Drop Cab",
description: "Kalyani Nagar to Mumbai Airport drop cab service provides reliable one-way transportation for passengers traveling to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport transfers. Professional drivers ensure safe driving and punctual pickup services."
},
{
name: "Kalyani Nagar to Mumbai Drop Cab",
description: "Kalyani Nagar to Mumbai drop cab service offers dependable one-way transportation for passengers traveling from Kalyani Nagar to Mumbai city. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Taxi Service in Kalyani Nagar Pune",
description: "Taxi service in Kalyani Nagar Pune provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe rides across Kalyani Nagar and nearby Pune areas."
},
{
name: "Cab Service in Kalyani Nagar",
description: "Cab service in Kalyani Nagar offers convenient transportation for city rides and long-distance journeys. Vehicles are well maintained and suitable for daily commuting, airport transfers, and intercity travel. Flexible booking options allow easy cab reservations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for passengers traveling from Pune to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport journeys."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for travelers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys."
},
{
name: "Kalyani Nagar to Mumbai Airport Cabs",
description: "Kalyani Nagar to Mumbai Airport cabs service offers reliable transportation for passengers traveling from Kalyani Nagar to Mumbai Airport. Comfortable vehicles with professional drivers ensure safe and punctual airport transfers."
},
{
name: "Wadgaon Sheri to Mumbai Cabs",
description: "Wadgaon Sheri to Mumbai cabs service provides dependable transportation between Wadgaon Sheri in Pune and Mumbai city. Vehicles are comfortable and suitable for long-distance highway travel."
},
{
name: "Car Rental Service in Kalyani Nagar",
description: "Car rental service in Kalyani Nagar offers flexible vehicle hire options for local travel and outstation journeys. Vehicles are well maintained and suitable for business trips, family travel, and airport transfers."
},
{
name: "Cab Service in Yerwada",
description: "Cab service in Yerwada provides reliable transportation for passengers traveling within Pune and nearby destinations. Comfortable vehicles and professional drivers ensure safe and smooth rides."
},
{
name: "Pune Mumbai Velocity Cabs",
description: "Pune Mumbai Velocity Cabs service offers dependable transportation between Pune and Mumbai via the expressway. Vehicles are comfortable and suitable for long-distance travel with experienced drivers ensuring safe journeys."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe rides across Pune and nearby cities."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Cab Service Kalyani Nagar Pune",
description: "Cab service Kalyani Nagar Pune provides reliable transportation for local rides, airport transfers, and outstation travel. Comfortable vehicles and professional drivers ensure safe travel across Kalyani Nagar and nearby Pune areas."
},
{
name: "Taxi Service Kalyani Nagar Pune",
description: "Taxi service Kalyani Nagar Pune offers dependable transportation for passengers traveling within Pune city and nearby destinations. Vehicles are comfortable and suitable for daily commuting and airport travel."
},
{
name: "Kalyani Nagar to Mumbai Taxi",
description: "Kalyani Nagar to Mumbai taxi service provides reliable intercity transportation between Pune’s Kalyani Nagar area and Mumbai city. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
}
],

tableData: [
["Kalyani Nagar to Mumbai Taxi Fare","Kalyani Nagar to Mumbai Airport Cab"],
["Kalyani Nagar to Dadar Cab","Kalyani Nagar to Mumbai International Airport Cab"],
["Kalyani Nagar to Mumbai One Day Cab","Kalyani Nagar to Mumbai Airport Drop Cab"],
["Kalyani Nagar to Mumbai Drop Cab","Taxi Service in Kalyani Nagar Pune"],
["Cab Service in Kalyani Nagar","Pune to Mumbai Airport Cab"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Kalyani Nagar to Mumbai Airport Cabs","Wadgaon Sheri to Mumbai Cabs"],
["Car Rental Service in Kalyani Nagar","Cab Service in Yerwada"],
["Pune Mumbai Velocity Cabs","Cab Service in Pune"],
["Pune Mumbai Cab","Cab Service Kalyani Nagar Pune"],
["Taxi Service Kalyani Nagar Pune","Kalyani Nagar to Mumbai Taxi"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Kalyani Nagar to Mumbai via the Mumbai Pune Expressway. Their knowledge of traffic conditions and highway routes ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Taxi Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Kalyani Nagar to Mumbai taxi bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "Our Kalyani Nagar to Mumbai taxi service operates 24 hours a day. Whether you need an early morning airport transfer, business trip, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Taxis",
    WhyChoosedescription: "All taxis in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way taxi service, round-trip bookings, airport transfers, and customized travel plans from Kalyani Nagar to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kalyani Nagar",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and residential complexes across Kalyani Nagar and nearby areas like Viman Nagar, Yerawada, Koregaon Park, and Kharadi."
  },
  {
    WhyChooseheading: "Trusted Intercity Taxi Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Kalyani Nagar to Mumbai taxi bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Kalyani Nagar to Mumbai taxi service?", answer: "Yes, Velocity Cabs provides reliable taxi services from Kalyani Nagar to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Kalyani Nagar to Mumbai taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Kalyani Nagar to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way taxi from Kalyani Nagar to Mumbai?", answer: "Yes, we provide both one-way and round-trip taxi services between Kalyani Nagar and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential complexes across Kalyani Nagar." },
  { question: "Are all taxis air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the taxi online?", answer: "Yes, customers can easily book Kalyani Nagar to Mumbai taxi services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and all major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Joshi",
    feedback:
      "The ride from Kalyani Nagar to Mumbai was handled very smoothly. The cab was comfortable, the timing was perfect, and the overall travel experience felt stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shruti Deshmukh",
    feedback:
      "Travel arrangements from Kalyani Nagar to Mumbai were excellent. The vehicle was clean, the journey was well-coordinated, and the drive remained comfortable throughout.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kalyani Nagar to Mumbai Taxi Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Kalyani Nagar to Mumbai taxi service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Dadar, and other Mumbai destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Kalyani Nagar, Wadgaon Sheri, and Yerwada to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};








  return (
    <div>
      <Helmet>
  <title>Kalyani Nagar to Mumbai Taxi | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Kalyani Nagar to Mumbai taxi with Velocity Cabs. Affordable one way, round trip & airport drop cabs. Ertiga, Innova & Crysta available for Dadar, Mumbai airport & more. Safe and reliable taxi service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kalyaninagartomumbaitaxi;